import {
  getArticleList
} from '@/api'
import share from '@/mixins/share-finder.js'
import dateFormat from '@/utils/dateformat.js'
import { mapState, mapMutations } from 'vuex'
import { querySubscribeApi, queryTemplateConfigInfoApi } from '../../api/services/launcher-user'

export default {
  name: 'article-list',
  mixins: [share],
  data() {
    return {
      list: [],
      banner: null,
      columnInfo: null,
      noMore: false,
      isLoading: false,
      msg: '正在加载',
      inited: false,
      subscribed: false
    }
  },
  filters: {
    handleTitle(item) {
      if (!item.title) return ''
      if (item.imageUrl) {
        if (item.title.length > 25) {
          return item.title.slice(0, 25) + '...'
        }
      }
      if (!item.imageUrl) {
        if (item.title.length > 37) {
          return item.title.slice(0, 37) + '...'
        }
      }
      return item.title
    },
    dateFormat(date) {
      return dateFormat(date, 'yyyy-mm-dd')
    }
  },
  computed: {
    ...mapState(['wechatUser', 'serviceConfig', 'wxConfigSuccess']),
    type() {
      return this.$route.params.type
    },
    title() {
      let urlTitle = this.serviceConfig.projectName
      if (urlTitle) {
        return urlTitle
      }
      return ''
    }
  },
  async created() {
    this.setDocumentTitle(this.title)
    this.initSubscribeElement()
    await this.getArticleList()
    this.inited = true
  },
  mounted () {
    this.initLoadMore()
  },
  methods: {
    ...mapMutations(['SET_SERVICE_CONFIG']),
    searchDetail(item) {
      this.$router.push({
        path: `/launcher-article/${item.newsId}`,
        query: {
          columnName: item.columnCode,
          source: 'column'
        }
      })
    },
    async getArticleList() {
      if (this.isLoading) return
      this.isLoading = true
      let params = {
        columnCodes: this.type,
        appCode: this.serviceConfig.appCode,
        showPermission: 9,
        direction: 'DOWN',
        end: new Date().getTime(),
        limit: '20',
        hasTop: 1
      }
      if (this.list.length > 0) {
        params.sortTimestamp = this.list[this.list.length-1].sortTimestamp
      }
      const res = await getArticleList(params)
      let result = res && res.data || {}
      if (result.data && result.data.length === 0) {
        this.noMore = true
        this.msg = '没有更多了'
      }
      if (result.code !== 1 || (result.data && result.data.length === 0)) return
      this.columnInfo = result.data[0].columnBeans.find(item => item.code === this.type)
      this.banner = this.columnInfo.image
      let tmpList = result.data.map((item) => {
        return {
          id: item.id,
          title: item.title,
          imageUrl: item.attribute.listImageUrl,
          publishTime: item.publishTime,
          newsId: item.newsId,
          columnCode: this.type,
          sortTimestamp: item.sortTimestamp
        }
      }).slice(0, 20)
      if (this.list.length === 0) {
        this.list = tmpList
      } else {
        this.list = this.list.concat(tmpList)
      }
      this.isLoading = false
      this.configShareOptions()
    },
    setDocumentTitle(title) {
      document.title = title
      let i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(() => {
          i.remove()
        }, 0)
      }
      document.body.appendChild(i)
    },
    configShareOptions() {
      this.$store.dispatch('set_share_info', {
        name: this.columnInfo.name || this.serviceConfig.projectName,
        title: this.columnInfo.name || this.serviceConfig.title,
        desc: this.columnInfo.introduction || this.serviceConfig.desc,
        imgUrl: this.columnInfo.image || this.serviceConfig.image,
        columnName: this.columnInfo.name,
        cb: this.onMenuShare
      })
    },
    initLoadMore () {
      window.addEventListener('scroll', (e) => {
        let dom = e.srcElement || e.target
        if (this.noMore || this.isLoading) return
        const {clientHeight, scrollHeight, scrollTop} = dom
        if (scrollTop >= scrollHeight - clientHeight) {
          this.getArticleList()
        }
      }, true)
    },
    registerSubscribeElement() {
      this.querySubscribe()
      var btns = document.getElementsByClassName('subscribe-btn');
      const that = this
      if (!btns) return
      for (let i = 0; i < btns.length; i++) {
        let btn = btns[i]
        const item = that.list[btns[i].getAttribute('data-index')]
        btn.addEventListener('success', function () {     
          // 成功失败都跳详情
          that.searchDetail(item)
        });   
        btn.addEventListener('error',function (e) {
          // 成功失败都跳详情
          if (e.detail === 20006) that.searchDetail(item)
        });
      }
    },
    async querySubscribe() {
      let triedTime = 0
      const sleep = () => new Promise(resolve => setTimeout(() => resolve(), 300))
      while (!this.wechatUser || !this.wechatUser.openid) {
        if (triedTime >= 500) break;
        await sleep()
        triedTime++
      }
      const params = {
        openId: this.wechatUser.openid,
        originId: this.serviceConfig.originId,
        templateId: this.serviceConfig.subscribeTemplate
      }
      const res = await querySubscribeApi(params)
      if (res.code === 1 && res.data && !res.data.subscriptionPopUp) this.subscribed = true
    },
    formatSubscribeHtml(item) {
      return `
        <div class="subscribe-container">
          ${item.imageUrl ? `<img src="${item.imageUrl}" class="list-img"/>` : ''}
          <div class="list-des ${item.imageUrl ? 'hasImg' : 'withoutImg'}">
            <p class="article-title">${this.$options.filters.handleTitle(item)}</p>
            <p class="article-time">${this.$options.filters.dateFormat(item.publishTime)}</p>
          </div>
        </div>
      `
    },
    async initSubscribeElement() {
      const sleep = () => new Promise(resolve => setTimeout(() => resolve(), 300))
      while (!this.wxConfigSuccess || (!this.list || !this.list.length)) {
        await sleep()
      }
      await this.getAndSetTemplateConfigInfo()
      console.log(this.serviceConfig, '!!!')
      // 不配置模板则不初始化
      if (this.wxConfigSuccess && !this.serviceConfig.subscribeTemplate) return
      this.registerSubscribeElement()
    },
    // 获取模板及按钮信息并更新到serviceConfig中
    async getAndSetTemplateConfigInfo() {
      const params = {
        columnCode: this.type,
        originId: this.serviceConfig.originId
      }
      const res = await queryTemplateConfigInfoApi(params)
      if (res.code === 1 && res.data && res.data.templateId) {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: res.data.templateId,
          button: res.data.button
        })
      } else {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: '',
          button: ''
        })
      }
    }
  },
}
